import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import { tn } from '@owl-nest/localize'
import * as model from '@owl-nest/models'
import { styles as S } from '@ulule/owl-kit-components/next'
import { text } from '@owl-nest/utils'

import * as projectModel from '../../../../models/project'
import { RootState } from '../../../../../reducers'

import { useNavigation } from '../../../../hooks/useNavigation'
import { PATHS } from '../../../../paths'

import { Diptych } from './Diptych'
import { AnimateCounter } from '../AnimateCounter'

type SupportersProps = {
  supportersCount: number
}

export function Supporters({ supportersCount }: SupportersProps): React.ReactElement<SupportersProps> {
  const navigation = useNavigation()
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  return (
    <Diptych
      handlers={{
        onClick: () => {
          navigation.to(PATHS.SUPPORTERS)
        },
        onMouseEnter: () => {},
        onMouseLeave: () => {},
        onTouchStart: () => {},
      }}
      leftZone={
        project.latest_supporter && (
          <S.image.Avatar src={model.user.avatar(project.latest_supporter, '40x40')} type="extra-small" />
        )
      }
      rightZone={
        <Content>
          <AnimateCounter id={supportersCount}>
            <S.heading.XS>{project.is_online ? text.numberToLocaleString(supportersCount) : '—'}</S.heading.XS>
          </AnimateCounter>
          <S.copy.S.regular>&nbsp;{tn('contribution', 'contributions', supportersCount)}</S.copy.S.regular>
        </Content>
      }
    />
  )
}

const Content = styled.div`
  display: flex;
  align-items: baseline;
  margin-left: 6px;
`
